import type { CSSProperties } from "react";

/** Entrance stagger for the signed-out pages: each block rises `ms` after
 *  the page mounts (see `.login-rise` in index.css). */
export function rise(ms: number): CSSProperties {
  return { "--login-delay": `${ms}ms` } as CSSProperties;
}
